<template>
  <div class="jc-page-content" v-load="loading">
    <div class="jc-panel jc-panel-padding">
      <div
        class="jc-container-result jc-result-info"
        style="width: 700px; margin: 0 auto; padding: 100px 0px 150px 0px"
      >
        <div class="jc-box-icon">
          <i class="jc-icon-information"></i>
        </div>

        <div class="jc-box-content">
          <template v-if="code === '0'">
            <h3>京东云授权合作渠道商邀请您成为他的客户</h3>

            <h5>邀请渠道商：{{ distributorName }}</h5>

            <p>
              备注：您确认邀请后，将通过该渠道商接受京东云服务，确认后您暂时不能更换渠道商
            </p>

            <div class="jc-box-action">
              <el-button type="primary" @click="accept">接受邀请</el-button>
            </div>
          </template>

          <template v-else>
            <h3>{{ message }}</h3>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getDistributorPublicInfo,
  addCustomer,
  customerValidator,
} from '@/api/distributor-api'
export default {
  props: [],
  components: {},
  mixins: [],
  data() {
    return {
      code: '0',
      distributorName: '',
      distributorId: this.$route.params.id,
      message: '',
      loading: false,
    }
  },
  watch: {},
  computed: {},
  mounted() {
    this.checkCustomerValidator()
    this.getInfo()
  },
  created() {},
  filters: {},
  methods: {
    async checkCustomerValidator() {
      this.loading = true
      const {
        result: { code, message },
      } = await customerValidator({
        distributorId: this.distributorId,
      })
      this.code = code
      this.message = message
      this.loading = false
    },
    async getInfo() {
      try {
        let {
          result: { distributorResult },
        } = await getDistributorPublicInfo({
          distributorId: this.distributorId,
        })
        this.distributorName =
          (distributorResult && distributorResult.distributorName) || ''
      } catch (e) {
        console.log(e)
      }
    },
    async accept() {
      let { result } = await addCustomer(this.distributorId)
      if (result && result.code === '1') {
        this.$jcNotify.error(result.message)
      } else {
        this.$router.push({
          name: 'status',
          params: {
            status: 'related-success',
          },
          query: {
            hideSideMenu: 1,
          },
        })
      }
    },
  },
}
</script>

<style>
.jc-container-result {
  margin-left: 200px;
  margin-right: 200px;
  margin-top: 100px;
  margin-bottom: 150px;
}
.jc-container-result .jc-box-icon {
  float: left;
}
.jc-container-result .jc-box-icon i {
  font-size: 60px;
}
.jc-container-result .jc-box-content {
  margin-left: 104px;
}
.jc-container-result .jc-box-content h3 {
  font-size: 24px;
  line-height: 36px;
  margin-bottom: 22px;
}
.jc-container-result .jc-box-content h5 {
  font-size: 12px;
  line-height: 18px;
  margin-bottom: 4px;
}
.jc-container-result .jc-box-content p {
  line-height: 18px;
  margin-bottom: 4px;
  color: #999999;
}
.jc-container-result .jc-box-content .jc-box-action {
  margin-top: 30px;
}
.jc-result-info.jc-container-result .jc-box-icon i {
  color: #2aafff;
}
.jc-result-success.jc-container-result .jc-box-icon i {
  color: #1bca69;
}
.jc-result-danger.jc-container-result .jc-box-icon i {
  color: #ff3a3a;
}
</style>
